<div class="row timer">
    <span class="material-icons md-light pr-2">
        timer
        </span>
    <span >{{minutes}}</span>
    <span>:</span>
    <span >{{seconds}}</span>
</div>
